const DEFAULT_PUBLIC_ASSET_ORIGIN = "https://oss.findinai.cn";

export const publicAssetOrigin = (
  process.env.NEXT_PUBLIC_ASSET_PREFIX || DEFAULT_PUBLIC_ASSET_ORIGIN
).replace(/\/$/, "");

export function publicAsset(path: string) {
  if (/^(https?:)?\/\//.test(path)) {
    return path;
  }

  return `${publicAssetOrigin}${path.startsWith("/") ? path : `/${path}`}`;
}

export function publicAssetCssUrl(path: string) {
  return `url('${publicAsset(path)}')`;
}
